module.exports = __webpack_public_path__ + "static/media/content.0f58fcc6.png";